export default {
    GritSandbox: {
        id: 'GritSandbox',
        name: 'GritSandbox',
        settings: {
            tenantName: 'gptestb2corg',
            Tenant: 'gptestb2corg.onmicrosoft.com',
            tenantId: 'dcce0867-073b-4819-9862-133adeb6bd7f',
            iefAppId: 'f9b3b389-0b7a-4690-aa21-128bfd2b30af',
            proxyIefAppId: '4fd657d2-9232-45c7-9246-736ed750c162',
            extensionsContainerClientId: 'e98d96c4-633d-478f-9518-460918ad25c1',
            extensionsContainerObjectId: 'e8f4092d-f8d6-493b-bb59-bc76299408ad',
            tokenSigningKeyContainer: 'B2C_1A_TokenSigningKeyContainer',
            tokenEncryptionKeyContainer: 'B2C_1A_TokenEncryptionKeyContainer',
            SAMLCert: 'B2C_1A_gpTestSamlTestCert',
            oidcTestApplicationId: 'de27c7d9-1880-447b-aa24-2ac363bd08d7',
            defaultSamlIssuerId: 'https://gptestb2corg.onmicrosoft.com',
            applicationInsightsInstrumentationKey: '3c6fb700-ea88-48fa-982f-596dce17316f',
            applicationInsightsClientEnabled: 'false'
        },
        readonlyDefaultSettings: true,
        linked: true
    },
    gritDevTenant: {
        id: 'gritDevTenant',
        name: 'gritDevTenant',
        settings: {
            tenantName: 'gpdevb2c',
            Tenant: 'gpdevb2c.onmicrosoft.com',
            tenantId: '7bd23860-e13d-4cf0-bbc7-a4a56c3dc0e3',
            iefAppId: 'a82e28dd-b16b-473a-a3a3-c3c486a5c59f',
            proxyIefAppId: 'eccdc34e-ac00-4609-914f-48a0b0393d67',
            extensionsContainerClientId: '9cbd6f17-3de3-4b61-badc-73d8f38abe19',
            extensionsContainerObjectId: 'db7ec858-bf05-46fe-bbb2-8a6aa462044e',
            tokenSigningKeyContainer: 'B2C_1A_TokenSigningKeyContainer',
            tokenEncryptionKeyContainer: 'B2C_1A_TokenEncryptionKeyContainer',
            SAMLCert: 'B2C_1A_samlTestCert',
            oidcTestApplicationId: '980626d3-2efc-402c-9335-f05c32d94ff8',
            defaultSamlIssuerId: 'https://gpdevb2c.onmicrosoft.com',
            applicationInsightsInstrumentationKey: '3c6fb700-ea88-48fa-982f-596dce17316f',
            applicationInsightsClientEnabled: 'false'
        },
        readonlyDefaultSettings: false,
        linked: true
    }
}